<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" v-bind:href="'#t1' + rowData.grupo_id + ''" role="tab" data-toggle="tab">
                        <span class="nav-link-in">
                            Detalhes
                            <i class="fa fa-bulding"></i>
                        </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
            role="tabpanel"
            class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
            v-bind:id="'t1' + rowData.grupo_id + ''">
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th>N° Nota Fiscal</th>
              <th>Status</th>
              <th>N° Volume</th>
              <th>Emissor</th>
              <th>Pedido</th>
              <th>Usuário bipador</th>
              <th>Data da bipagem</th>
              <th>Ocorrências</th>
              <th>Parado a</th>
            </tr>
            </thead>
            <tbody>
            <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_fiscal_volume_bip">
              <td>
                {{ item.doc_fiscal.num_fiscal }}
              </td>
              <td v-for="(invoice_volume_log, index) in item.doc_fiscal_volume.doc_fiscal_volume_log" :key="index"
                  v-if="index === 0">
                {{ invoice_volume_log.descr }}
              </td>
              <td>
                {{ item.doc_fiscal_volume.num_volume }}
              </td>
              <td>
                {{ item.doc_fiscal.doc_fiscal_partes_env_emi.emi_nome }}
                ({{ formatDocumentCompany(item.doc_fiscal.doc_fiscal_partes_env_emi.emi_cnpj) }})
              </td>
              <td>
                {{ item.doc_fiscal.doc_fiscal_adicional.cd_pedido || 'N/A' }}
              </td>
              <td>
                {{ item.usuario_inc.email }}
              </td>
              <td>
                {{ formatToBrazilianDate(item.dt_inc) }}
              </td>
              <td class="dropdown">
                <div
                    v-for="(descr, index) in getLatestItemByCreatedAt(item.doc_fiscal_volume.doc_fiscal_volume_ocorrencia)"
                    :key="index">
                  <span class="badge badge-primary"> {{ descr }} </span>
                </div>
              </td>
              <td>
                {{ rowData.volume_parado_dias }} dias
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {formatDateTime, formatToBrazilianDate} from '../utils';

export default {
  data() {
    return {
      helpForm: new Form({permissionRole: [], params: []}),
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    formatToBrazilianDate,
    getLatestItemByCreatedAt(items) {
      if (items.length) {
        return items.map((item) => item.descr);
      }
      return '<p>N/A</p>';
    },
    formatDocumentCompany(data) {
      return data.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  }
}
</script>
